import { Col, Form, InputProps, Modal, ModalProps, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  memo,
  useEffect,
  useState,
} from 'react';

import { Button, InputForm, SelectForm } from 'components';
import { IUserPermission, IUserPermissionForm } from 'interfaces/User/User';
import { IRole } from 'interfaces/Role/Role';
import { title } from 'process';
import { toastError } from 'utils/constants/functions';
// import { rolesBase } from './PermissionPage';
type IProps = {
  // roles: IRole[];
  data: IUserPermission;
  branch: any;
  onFinish: (values: any) => void;
  roleBase: IRole[];
  setOpen: Dispatch<SetStateAction<boolean>>;
} & ModalProps;

type IFields = {
  label?: ReactNode;
  component?: ReactNode;
  inputProps: InputProps;
};

const ModalPermission = ({
  data,
  // roles,
  branch,
  roleBase,
  setOpen,
  onFinish,
  ...props
}: IProps) => {
  const { open, title } = props;

  const [form] = useForm<IUserPermissionForm>(),
    [fields, setFields] = useState<IFields[]>([]);

  useEffect(() => {
    const fields: IFields[] = [
      {
        inputProps: {
          disabled: true,
          name: 'fullName',
          placeholder: 'Nhập tên nhân viên',
        },
        label: 'Tên nhân viên',
      },
      {
        inputProps: {
          name: 'email',
          disabled: true,
          placeholder: 'Nhập email',
        },
        label: 'Email',
      },
      {
        inputProps: {
          name: 'plantCode',
        },
        label: 'Chi nhánh',
        component: (
          <SelectForm
            size="middle"
            allowClear={false}
            placeholder="Chọn chi nhánh"
            options={branch}
            className="max-w-[330px] h-[40px] text-start"
          />
        ),
      },
      {
        inputProps: {
          name: 'role',
        },
        label: 'Quyền',
        component: (
          <SelectForm
            size="middle"
            placeholder="Chọn quyền"
            options={roleBase.map((role) => ({
              value: role?.id,
              label: role?.name,
            }))}
            className="max-w-[330px] h-[40px] text-start"
          />
        ),
      },
    ];

    setFields(fields);
  }, [open]);

  useEffect(() => {
    if (!Object.keys(data).length) return;

    const fieldsValue: IUserPermissionForm = {
      fullName: data.fullName,
      email: data.email,
      role: data.role,
      plantCode: data.plantCode,
      // role: roleBase.map((role) => role.name).includes(data?.role)
      //   ? roleBase.find((role) => role.name === data?.role)?.name
      //   : data?.trole?.name,
    };

    form.setFieldsValue(fieldsValue);
  }, [open, data]);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleClickSave = () => {
    const fields = form.getFieldsValue();
    // if (!fields.role) {
    //   toastError('Vui lòng chọn quyền');
    //   return;
    // }

    onFinish(fields);
    form.resetFields();
  };

  return (
    <Modal
      open={open}
      title={title}
      onCancel={handleCancel}
      classNames={{
        content: '!p-0',
        header:
          '!px-[24px] !pt-[20px] !pb-[8px] !border-sub !border-solid !border-b-[1px]',
        body: '!px-[42px]',
        footer: '!px-[24px] !py-[20px] !bg-rowTable !rounded-b-[8px]',
      }}
      footer={() => (
        <Row gutter={[8, 16]} justify={'end'} align={'middle'}>
          <Col>
            <Button
              fill
              title={'Huỷ'}
              customClass="!bg-rowTable !border-transparent !text-neutral-30"
              handleOnclick={handleCancel}
            />
          </Col>
          <Col>
            <Button
              fill
              title={'Lưu'}
              customClass="w-[131px]"
              handleOnclick={handleClickSave}
            />
          </Col>
        </Row>
      )}
    >
      <Form form={form}>
        {fields.map((field, index) => {
          const { name } = field.inputProps;

          return (
            <Form.Item
              key={index}
              name={name}
              label={field.label}
              className="text-end"
            >
              {field.component ? (
                field.component
              ) : (
                <InputForm
                  size="middle"
                  className="w-[330px] h-[40px]"
                  {...field.inputProps}
                />
              )}
            </Form.Item>
          );
        })}
      </Form>
    </Modal>
  );
};

export default memo(ModalPermission);
